import "../styles/widget.css";
import { World } from "./world/world";
import { IPA_GLOBE_DEFAULTS } from "./world/ipa-globe-defaults";

const instances = new WeakMap();

function parseOpts(wrapper) {
  let raw = {};
  try {
    raw = JSON.parse(wrapper.getAttribute("data-ipa-globe") || "{}");
  } catch (e) {
    raw = {};
  }
  return { ...IPA_GLOBE_DEFAULTS, ...raw };
}

export function mountIPAGlobe(wrapper) {
  const mount = wrapper.querySelector(".ipa-globe-mount");
  if (!mount || instances.has(mount)) {
    return;
  }
  const world = new World(mount, parseOpts(wrapper));
  world.start();
  instances.set(mount, world);
}

function bootDocument() {
  document.querySelectorAll(".ipa-globe-widget").forEach((el) =>
    mountIPAGlobe(el)
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootDocument);
} else {
  bootDocument();
}

function bindElementor() {
  if (
    typeof window.elementorFrontend === "undefined" ||
    !window.elementorFrontend.hooks
  ) {
    return;
  }
  window.elementorFrontend.hooks.addAction(
    "frontend/element_ready/ipa_globe",
    ($scope) => {
      $scope.find(".ipa-globe-widget").each(function () {
        mountIPAGlobe(this);
      });
    }
  );
}

function hookElementorWhenReady() {
  if (
    typeof window.elementorFrontend !== "undefined" &&
    window.elementorFrontend.hooks
  ) {
    bindElementor();
    return;
  }
  if (window.jQuery) {
    window.jQuery(window).on("elementor/frontend/init", bindElementor);
  }
}

hookElementorWhenReady();
